import script from "./MovesWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./MovesWidget.vue?vue&type=script&setup=true&lang=ts"

import "./MovesWidget.vue?vue&type=style&index=0&id=6dee391e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dee391e"]])

export default __exports__